<template>
	<div class="ai_container">
		<Header :onPrev="handlePrev" :isShowHome="true" :title="'내 정보 관리'" />
		<div class="mypage_wrapper">
			<div class="mypage_userinfo_login_wrapper">
				<p class="heading_7">로그인 정보</p>
				<LoginSocial :provider="'kakao'" />
			</div>
			<div class="mypage_userinfo_wrapper">
				<p class="heading_7" style="marginBottom: 16px">회원정보</p>
				<p class="body_9">정보변경 필요 시 각 간편 로그인 계정 정보를 변경 후 재 로그인 해주세요.</p>
				<ul>
					<li>
						<b class="body_7_M f_gray_4">이름</b>
						<p class="body_7 f_gray_5">{{ decriptName }}</p>
					</li>
					<li>
						<b class="body_7_M f_gray_4">성별</b>
						<p class="body_7 f_gray_5">{{ gender }}</p>
					</li>
					<li>
						<b class="body_7_M f_gray_4">생년월일</b>
						<p class="body_7 f_gray_5">{{ decriptBirthday }}</p>
					</li>
					<li>
						<b class="body_7_M f_gray_4">휴대폰번호</b>
						<p class="body_7 f_gray_5">{{ decriptMobile }}</p>
					</li>
				</ul>
			</div>
			<button class="withdraw f_red_1" @click="handleWithdrawCheck">회원탈퇴</button>
		</div>
		<Alert
			:isVisible="isOpenAlert"
			:title="'회원탈퇴'"
			:content="`탈퇴하시면 계정을 다시 복구할 수 없으며,\n30일간 동일 명의로 가입이 불가능해요.\n정말 탈퇴하시겠어요?`"
			:primaryText="'회원탈퇴'"
			:secondaryText="'아니요'"
			:onClickSecondary="toggleAlert"
			:onClickPrimary="handleWithdraw" />
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import { EventBus } from "@/modules/event-bus"
import Header from '../../../components/ai/AiHeader.vue'
import Footer from '../../../components/ai/AiFooter.vue'
import Alert from '../../../components/ai/AiAlert.vue'
import LoginSocial from '../../../components/ai/AiLoginSocial.vue'
export default {
	data() {
		return {
			hasPendingHistory: false,
			isOpenAlert: false,
			decriptName: Vue.$sessionStorage.get('decriptName'),
			decriptBirthday: Vue.$sessionStorage.get('decriptBirthday'),
			decriptMobile: Vue.$sessionStorage.get('decriptMobile'),
			gender: Vue.$sessionStorage.get('gender') == null ? '' : Vue.$sessionStorage.get('gender') == 'M' ? '남' : '여',
			params: {
				userNo: Vue.$sessionStorage.get('userNo'),
				ci: '',
			},
		}
	},
	components: {
		Header,
		Footer,
		Alert,
		LoginSocial
	},
	methods: {
		handlePrev() {
			//alert('뒤로가기')
		},
		handleWithdrawCheck() {

			//견적이 있는지 확인하는 로직이 들어갈 자리
			//현재는 무조건 견적확인 알림 화면으로 이동
			Vue.httpClient
				.post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/aiEstimateStatus', this.params)
				.then(response => {
					if (response.data.result) {
						if(response.data.result.aiEstimateStatus == null){
							this.hasPendingHistory = false
						}else if(response.data.result.aiEstimateStatus > 10 && response.data.result.aiEstimateStatus <= 99){
							this.hasPendingHistory = false
						}else{
							this.hasPendingHistory = true
						}

						if (this.hasPendingHistory) {
							//alert('견적이 존재할 경우 견적내역 확인 알림 화면으로 이동')
							Vue.$sessionStorage.set('estimateNo', response.data.result.estimateNo);
							Vue.$sessionStorage.set('estimateDate', response.data.result.estimateDate);
							this.$router.push({ name: 'AiMypageWithdraw' })
						} else {
							this.toggleAlert()
						}
					}
				})
		},
		handleWithdraw() {
			//alert('회원탈퇴')
			//회원정보 30일 유지할지 몰라서 일단 중지

			Vue.httpClient
				.post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/aiUserWithdraw', this.params)
				.then(response => {
					if (response.data.result) {
						window.$store.commit('Login/setToken', { token: null })
						window.$store.commit('Login/setUserNo', { userNo: null })
						Vue.httpClient.defaults.headers.common['x-auth-token'] = null;
						Vue.$sessionStorage.clear();
						//Vue.use(VueCookies);
						//모든 쿠키 키 가져오기
						//this.$cookies.keys().join("\n");
						//VueCookies.keys().forEach(cookie => VueCookies.remove(cookie));
						EventBus.$emit("ai-event-logout");
						this.$router.push({ name: 'AiMain' })
					}
				})
		},
		toggleAlert() {
			this.isOpenAlert = !this.isOpenAlert
		}
	}
}
</script>

<style scoped>
.mypage_wrapper {
	position: relative;
	height: calc(100dvh - var(--ai-header-height));
	background-color: var(--gray-scale-11);
}

.mypage_userinfo_login_wrapper {
	padding: 16px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: var(--gray-scale-12);
	border-bottom: 10px solid var(--gray-scale-11);
}

.mypage_userinfo_wrapper {
	padding: 24px 20px;
	background-color: var(--gray-scale-12);
}

.mypage_userinfo_wrapper>ul {
	margin-top: 16px;
	display: grid;
	gap: 12px;
}

.mypage_userinfo_wrapper>ul>li {
	display: flex;
	align-items: center;
}

.mypage_userinfo_wrapper>ul>li>b {
	min-width: 80px;
}

.mypage_wrapper>.withdraw {
	position: absolute;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/ai/mypage/AiMypageUserInfo.vue